module.exports = __webpack_public_path__ + "static/media/cuteCut-03.926be0e8.png";